/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Input, Select, InputNumber, Modal} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice} from 'Utils';
import './invoice.css';
import {
    getProductList3,
    setProductUp,
    getProductCategory,
    getEditData,
    getHead,
    getBodyList,
    getGouXiao,
    getYouJi,
    giveNormal,
    changeText,
    goNext,
    directInvoiceInfo, getSaleInvoiceBank, getSalesUnitApproveList
} from '../../service/invoiceManagement';
import {Store, Actions} from './store';

class invoiceStaging extends Reflux.Component {
    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.state = {
            opts: ['开票明细'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                startDate: d.format('yyyy-MM-dd'),
                endDate: d.format('yyyy-MM-dd'),
                s: 10,
                p: 1
            },
            categoryData: [],
            button_limits_end: {},
            detailData: {},  // 头信息
            detailData2: [], // 购销单位
            detailData3: [], // 邮寄地址选项
            giveAddress: '',  // 邮寄地址
            giveAddressId: '',  // 邮寄地址ID
            resData: '',  // 开票详情数据
            saleInvoiceBank: [],//销方银行
            saleInvoiceBankRender: false,
            saleBank: '',
            loading: true,
            specialBillingType: '',//修改类型
            confirmvisible: false,
            confirmLoading: false,
            usable: false,
            coable: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.nextChange = this.nextChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.rowOnChange = this.rowOnChange.bind(this);
        this.rowOnChange2 = this.rowOnChange2.bind(this);
        this.rowOnChange3 = this.rowOnChange3.bind(this);
        this.rowOnChange4 = this.rowOnChange4.bind(this);
        this.rowOnChange5 = this.rowOnChange5.bind(this);
    }

    /*返回*/
    backHandle() {
        //window.history.go(-1);
        this.goView('/invoiceManagement');
    }

    /*选择*/
    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    };

    /*筛选*/
    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    /*移除暂存*/
    removeChange() {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        setProductUp(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '移除成功', '');
                self.initData();
            } else {
                openNotice('error', '移除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*下一步*/
    nextChange() {
        alert("下一步")
    };


    goView(url) {
        hashHistory.push(url);
    };

    /*重置*/
    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                name: '',
                category: [],
                active: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        self.setState({
            loading: true
        });

        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        getProductCategory().then(function (result) {
            /* 产品分类 */
            if (!result || result.code != 200) {
                openNotice('error', '产品分类数据获取失败，请重试', '');
                return;
            }
            // console.log(result);
            self.setState({
                categoryData: result.data || []
            });
        });

        let _state = this.props.location.state
            , _type = _state.type, _id = _state.id;
        if (_type == 'direct') {
            directInvoiceInfo(
                [..._state.list]
            ).then(res => {
                if (res && res.code == 200) {
                    console.log(res);
                    console.log(_state.list2);
                    let _line = res.data.lineSyncList || [];
                    if (_state.list2) {
                        for (var i = 0; i < _line.length; i++) {
                            _line[i].totalAmount = parseFloat((_line[i].totalAmount / _line[i].qty * _state.list2[i].qty).toFixed(4))
                            _line[i].taxValue = parseFloat((_line[i].taxValue / _line[i].qty * _state.list2[i].qty).toFixed(4))
                            _line[i].amount = parseFloat((_line[i].amount / _line[i].qty * _state.list2[i].qty).toFixed(4))
                            _line[i].qty = _state.list2[i].qty
                            _line[i].adjustDesc = _state.list2[i].adjustDesc
                            _line[i].adjustUnit = _state.list2[i].adjustUnit
                            _line[i].newDescCategories = _state.list2[i].newDescCategories
                        }
                    }
                    self.setState({
                        'rows': _line,
                        'total': _line.length || 0,
                        'detailData': res.data,
                        'resData': res.data,
                        'loading': false
                    }, () => {
                        getSalesUnitApproveList('salesUnitApproveList').then(ress => {
                            if (ress.status) {
                                ress.data.forEach(x => {
                                    if (x.sKey == res.data.cusId) {
                                        self.setState({saleInvoiceBankRender: true})
                                    }
                                });
                            }
                        });
                        this.computeAmounts();
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            });
        } else if (_type == 'edit') {
            getEditData(_id).then(result => {
                // console.log(result);
                if (result && result.status == true) {
                    self.setState({
                        'rows': result.data.lineSyncList || [],
                        'total': result.data.lineSyncList.length || 0,
                        'detailData': result.data,
                        'resData': result.data,
                        'giveAddress': result.data.address,
                        'giveAddressId': result.data.addressId,
                        'remark': result.data.remark,
                        'newSalesUnit': result.data.newSalesUnit,
                        'specialBillingType': result.data.specialBillingType,
                        'saleBank': result.data.saleInvoiceBank,
                        'loading': false,
                        'coable': false
                    }, () => {
                        getSalesUnitApproveList('salesUnitApproveList').then(res => {
                            if (res.status) {
                                res.data.forEach(x => {
                                    if (x.sKey == result.data.cusId) {
                                        self.setState({saleInvoiceBankRender: true})
                                    }
                                });
                            }
                        });
                        this.computeAmounts();
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            });
        } else {
            let salesUnitId = _state.salesUnitId
                , salesChannelCode = _state.salesChannelCode
                , ids = _state.ids
            ;
            goNext({
                salesUnitId,
                salesChannelCode,
                ids
            }).then(result => {
                // console.log(result);
                if (result && result.code == 200) {
                    self.setState({
                        'rows': result.data.lineSyncList || [],
                        'total': result.data.lineSyncList.length || 0,
                        'detailData': result.data,
                        'resData': result.data,
                        'loading': false
                    }, () => {
                        this.computeAmounts();
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            });
        }
        /*getBodyList({id:this.props.params.id,p:1,s:10}).then(function (result) {
          if (result && result.code == 200) {
            self.setState({
              'rows': result.data || [],
              'total': result.total
            });
          } else {
            openNotice('error', '数据获取失败', '');
          }
        });
        getHead({id:this.props.params.id}).then(result => {
          // console.log(result.data);
          // debugger
          // var data = result.data
          var detailData = [...this.state.detailData];
          detailData = result.data;
          self.setState({detailData})
        })*/
        getGouXiao().then(res => {
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.gouxiaoUomName,
                        value: x.gouxiaoUomId
                    });
                });
                self.setState({detailData2: arr})
            }
        })
        getYouJi().then(res => {
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.address,
                        value: x.address
                    })
                });
                self.setState({detailData3: arr})
            }
        });
        getSaleInvoiceBank().then(res => {
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.description,
                        value: x.name
                    })
                });
                self.setState({saleInvoiceBank: arr})
            }
        });
    };

    /* 金额计算 */
    computeAmounts() {
        let _list = this.state.rows
            , totalAmount = 0
            , amount = 0
            , taxAmount = 0
        ;
        _list.forEach((d, i) => {
            totalAmount += Number(d.totalAmount);
            // amount += Number(d.price * d.qty);
            amount += Number(d.amount);
        });
        totalAmount = parseFloat(totalAmount.toFixed(2));
        amount = parseFloat(amount.toFixed(2));
        taxAmount = parseFloat(Math.abs(amount - totalAmount).toFixed(2));
        this.setState({
            totalAmount,
            amount,
            taxAmount
        })
    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentDidMount() {
        // let self = this;
        // // console.log();

        // // debugger

        // // getBodyList({id:this.props.params.id}).then(result => {
        // //  console.log(result);

        // // })
        // const data = this.store.state;
        // if(data.useStore) { //根据useStore的值判断是否使用store中的数据
        //   this.setState({
        //     ...this.state,
        //     searchObj: {
        //       ...this.state.searchObj,
        //       ...data.params
        //     },
        //     key: data.params.buyerStatus || 0
        //   });
        // }
        // getProductCategory().then(function (result) {
        //  /* 产品分类 */
        //  if (!result || result.code != 200) {
        //    openNotice('error', '产品分类数据获取失败，请重试', '');
        //    return;
        //  }
        //  console.log(result);
        //  self.setState({
        //    categoryData: result.data || []
        //  });
        // });
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    changeRemark(value) {
        // console.log(value.target.value);
        this.setState({detailData: {...this.state.detailData, remark: value.target.value}, remark: value.target.value});
        // console.log(value.target.value)
    }

    changeRemark2(value) {
        // console.log(value.target.value);
        this.setState({
            detailData: {...this.state.detailData, newSalesUnit: value.target.value},
            newSalesUnit: value.target.value
        });
        // console.log(value.target.value)
    }

    /*componentDidMount () {

      //设置离开当前路由时的钩子函数
      this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
      this.setState({
        button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
      });
    }*/

    /* 选择邮寄地址时 */
    onSelectFn(value) {
        let _list = this.state.detailData3;
        _list.forEach((item, index) => {
            if (item.value == value) {
                this.setState({
                    // giveAddressId: value,
                    giveAddress: item.text
                });
            }
        });
        window.isChoseMaillAddress = true;
    }

    /* 邮寄地址改变时 */
    handleChange(value) {
        if (window.isChoseMaillAddress) {
            window.isChoseMaillAddress = false;
        } else {
            this.setState({
                giveAddressId: '',
                giveAddress: value
            });
        }
    }

    handleChange2(value) {
        // console.log(value);
        var gouxiaoUomId = value.key;
        var gouxiaoUomName = value.label;
        this.setState({gouxiaoUomId: gouxiaoUomId, gouxiaoUomName: gouxiaoUomName});
    }

    /* 特殊开票修改类型 */
    handleChange3(value) {
        // console.log(value);
        var specialBillingType = value.key;
        this.setState({specialBillingType: specialBillingType})
    }

    /* 提交 && 保存 */
    submitHandle(tag) {
        /*if (!this.state.gouxiaoUomId) {
          openNotice('warning', '请选择购销单位');
          return;
        }*/
        // if (!this.state.giveAddress.trim()) {
        //     openNotice('warning', '请选择邮寄地址');
        //     return;
        // }
        if (!this.state.specialBillingType) {
            openNotice('warning', '请选择修改类型');
            return;
        }
        this.setState({confirmLoading: true, usable: true});
        var giveList = {
            ...this.state.resData,
            type: 'Special',
            id: this.props.location.state.id || '',
            subOrSave: tag, // 提交sub 保存 save,
            // gouxiaoUomId:this.state.gouxiaoUomId,
            gouxiaoUomName: this.state.gouxiaoUomName,
            specialBillingType: this.state.specialBillingType,
            address: this.state.giveAddress.trim(),
            //addressId: this.state.giveAddressId,
            remark: this.state.detailData.remark ? this.state.detailData.remark.trim() : this.state.detailData.remark,
            newSalesUnit: this.state.detailData.newSalesUnit,
            taxAmount: this.state.taxAmount,
            amount: this.state.amount,
            totalAmount: this.state.totalAmount,
            saleInvoiceBank: this.state.saleBank
        };
        // console.log(giveList);
        // return
        giveNormal(giveList).then(result => {
            // console.log(result);
            // if (result && result.status == true ) {
            //   openNotice('success','开票成功');
            //   this.goView( `/invoiceManagement`);
            // } else {
            //   openNotice('error',result.message);
            // }
            if (result && result.status == true) {
                this.setState({confirmLoading: false, usable: false, coable: false});
                if (tag == 'sub') {
                    openNotice('success', '提交成功')
                    this.goView(`/invoiceManagement`);
                } else if (tag == 'save') {
                    openNotice('success', '保存成功')
                    this.goView(`invoiceManagement/${result.data.id}/Special`);
                }
                //  this.goView(`/invoiceManagement`);
            } else {
                this.setState({confirmLoading: false, confirmvisible: false, usable: false});
                openNotice('error', result.message);
            }
        })
    }

    /*submitHandle2 () {
      var giveList = {
        ...this.state.resData,
        type: 'Special',
        id:this.props.params.id,
        gouxiaoUomId:this.state.gouxiaoUomId,
        gouxiaoUomName:this.state.gouxiaoUomName,
        newSalesUnit:this.state.detailData.newSalesUnit,
        address:this.state.giveAddress,
        addressId:this.state.giveAddressId,
        remark:this.state.detailData.remark,
        subOrSave:'save', // 提交sub 保存 save

      };
      giveNormal(giveList).then( result => {
        console.log(result);
        if (result.code == 200 ) {
          this.goView(`/invoiceManagement`);
        }
      })
    }*/

    /* 数量 */
    rowOnChange(record, index, num) {
        // console.log(record)
        // console.log(index)
        //           console.log(text)
        // debugger
        const self = this;

        // if (num == 0 || num < 0 || typeof num == 'string' || !num || num == '' ){
        //   return
        // }
        if (typeof num == 'string' || !num || num == '') {
            return
        }
        if (record.resQty && Math.abs(num) > Math.abs(record.resQty)) {
            return
        }
        var rows = this.state.rows
            , resData = this.state.resData
        ;
        // console.log(text);
        /*changeText({
          id:record.id,
          qty:num,
          taxCode:record.taxCode,
          price:record.price
          }).then(function (result) {
          //  console.log(result)
          // console.log(rows[index].amount);
          if ( result.status ==true) {*/
        // let amount = num * record.price * (1 - record.taxCode/100)
        // let amount = num * record.price * (1 - record.calcTaxCode)
        let _price = record.price / (1 + Number(record.calcTaxCode))
            , amount = num * _price
            , totalAmount = record.price * num
        ;
        rows[index].amount = amount.toFixed(2);
        rows[index].totalAmount = totalAmount.toFixed(2);
        resData.lineSyncList = rows;
        resData.lineSyncList[index].qty = num;
        self.setState({
            rows: rows,
            resData
        }, () => {
            this.computeAmounts();
        });
        /*}
      });*/
    }

    /* 说明调整 */
    rowOnChange2(record, index, event) {
        debugger;
        let _dat = this.state.resData
            , _list = _dat.lineSyncList
        ;
        var value = event.target.value;
        _list[index].adjustDesc = value;

        this.setState({
            resData: _dat
        })
    }

    /* 新物料大类 */
    rowOnChange3(record, index, item) {
        let _dat = this.state.resData
            , _list = _dat.lineSyncList
        _list[index].newDescCategories = item;
        this.setState({
            resData: _dat
        }, () => {
            // console.log(this.state.resData.lineSyncList);
        })

    }

    //新单位
    rowOnChange5(record, index, event) {
        let _dat = this.state.resData
            , _list = _dat.lineSyncList
        ;
        var value = event.target.value;
        _list[index].adjustUnit = value;

        this.setState({
            resData: _dat
        })
    }

    /* 备注 */
    rowOnChange4(record, index, event) {
        // console.log(record.remark);
        // console.log(record);
        // console.log(index);
        // console.log(event);
        // debugger
        let _dat = this.state.resData
            , _list = _dat.lineSyncList
        ;
        var value = event.target.value;
        _list[index].remark = value;

        this.setState({
            resData: _dat
        }, () => {
            // console.log(this.state.resData.lineSyncList);
        })


        /*changeText({
          id:value.id,
          remark:record1
          }).then(function (result) {
          console.log(result);
          // value. = result.amount
        });*/
    }

    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    }
    handleCancel = () => {
        this.setState({
            confirmvisible: false,
            confirmLoading: false,
        });
    }

    onChangeSalsBank(value) {
        this.setState({
            saleBank: value
        });
    }


    render() {
        const {
            button_limits_end,
            opts,
            key,
            rows,
            total,
            searchObj,
            orderNumberList,
            invoiceNumberList,
            totalAmountList,
            invoiceCodeList,
            statusList,
            amountList,
            orderCreatedDateList,
            discountRateList,
            taxAmountList,
            remarkList,
            addressPhoneList,
            discountList,
            weiSalesUnitList,
            bankList,
            taxpayersList,
            salesUnitList,
            customerNameList,
            addressList,
            courierNumberList,
            gouxiaoUomList,
            salesChannelCodeList,
            detailData,
            detailData2,
            detailData3,
            loading,
            categoryData,
            specialBillingType,
            confirmLoading,
            confirmvisible,
            saleInvoiceBank,
            saleInvoiceBankRender
        }
            = this.state;
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'lineId',
            paginationHide: true,
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                // {
                //     title: '订单编号',
                //     width: 100,
                //     dataIndex: 'name',
                // },
                // {
                //     title: '出库单号',
                //     dataIndex: 'categoryText'
                // },
                // {
                //     title: '下单日期',
                //     dataIndex: 'showPrice'
                // },
                // {
                //     title: '出库日期',
                //     dataIndex: 'unitText'
                // },
                // {
                //     title: '购货单位',
                //     dataIndex: 'unitText'
                // },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                    width: 200
                },
                {
                    title: '物料描述调整',
                    dataIndex: 'adjustDesc',
                    render: (text, record, index) => {
                        return (<div>
                            <Input style={{width: 200}} onChange={this.rowOnChange2.bind(this, record, index)}
                                   defaultValue={text || ''} value={text} maxLength={36}/>
                        </div>)
                    }
                },
                {
                    title: '物料类别',
                    dataIndex: 'itemCategory'
                },
                {
                    title: '物料类别调整',
                    dataIndex: 'newDescCategories',
                    render: (text, record, index) => {
                        return (
                            <div>
                                {/*<Input style={{width: 50}} onChange={this.rowOnChange3.bind(this,record,index)} defaultValue={text || ''}/>*/}
                                <Select
                                    value={text}
                                    mode="combobox"
                                    className="categorySelect"
                                    onChange={this.rowOnChange3.bind(this, record, index)}
                                >
                                    {categoryData.map(function (item, key) {
                                        return <Select.Option key={key + ''}
                                                              value={item.label + ''}>{item.label}</Select.Option>
                                    })}
                                </Select>
                            </div>
                        )
                    }
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '单位调整',
                    dataIndex: 'adjustUnit',
                    render: (text, record, index) => {
                        return (<div>
                            <Input style={{width: 50}} onChange={this.rowOnChange5.bind(this, record, index)}
                                   defaultValue={text || ''} value={text} maxLength={10}/>
                        </div>)
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'qty',
                    render: (text, record, index) => (
                        <InputNumber style={{width: 50}}
                            // min={1}
                                     onChange={this.rowOnChange.bind(this, record, index)} defaultValue={text}
                                     value={this.state.rows[index].qty}/>
                    )
                },
                {
                    title: '单价(元)',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        return (text / (1 + Number(record.calcTaxCode))).toFixed(5);
                    }
                },
                {
                    title: '金额',
                    dataIndex: 'amount'
                },
                {
                    title: '税码',
                    dataIndex: 'taxCode'
                },
                {
                    title: '总金额',
                    dataIndex: 'totalAmount'
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => {
                        return (<div>
                            <Input style={{width: 50}} onChange={this.rowOnChange4.bind(this, record, index)}
                                   defaultValue={text || ''}/>
                        </div>)
                    }
                },
                {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                },
            ],
            rows,
        };
        return <div>
            <div className="companyTitle">
                <h1>{detailData.salesUnitName}</h1>
                <Button style={{marginLeft: 10, float: 'right'}} key="back"
                        onClick={this.backHandle.bind(this)}>返回</Button>
                {button_limits_end.invoiceManagement_specialInvoice_02 &&
                    <Button onClick={this.submitHandle.bind(this, 'save')}
                            style={{marginLeft: 10, float: 'right'}} disabled={this.state.usable}>保存</Button>}
                {button_limits_end.invoiceManagement_specialInvoice_03 &&
                    <Button onClick={this.showModal}
                            style={{marginLeft: 10, float: 'right'}} type="primary">提交</Button>}
                < Modal title="注意"
                        visible={confirmvisible}
                        onOk={this.submitHandle.bind(this, 'sub')}
                        confirmLoading={confirmLoading}
                        onCancel={this.handleCancel}
                >
                    <p>{"提交后将无法修改、删除，确认提交?"}</p>
                </Modal>
            </div>
            <div className="dms-table-box" style={{padding: 0, position: 'relative'}}>
                <div className="invoice_detail">
                    <div className="infor">
                        <a style={{'width': '32%'}}>
                            <p><label>订单编号:</label><span>{detailData.orderNumber || '-'}</span></p>
                            {/*<p><label>增值税发票代码:</label><span>{detailData.invoiceCode || '-'}</span></p>*/}
                            <p><label>开票日期:</label><span>{detailData.orderCreatedDate || '-'}</span></p>
                            <p><label>备注:</label><Input style={{width: '200px'}} type="text"
                                                          className="gouxiaoUomList"
                                                          onChange={this.changeRemark.bind(this)}
                                                          value={this.state.remark}
                                                          maxLength={'100'}/></p>
                            <p><label>未结购货单位:</label><span>{detailData.weiSalesUnit || '-'}</span></p>

                            <p><label>纳税人识别号:</label><span>{detailData.taxPayers || '-'}</span></p>
                            <p><label>客户名称:</label><span>{detailData.customerName || '-'}</span></p>
                            {/*<p><label className="ant-form-item-required">购销单位:</label>*/}
                            <p><label>购销单位:</label>
                                <span>{detailData.gouxiaoUomName || '-'}</span>
                                {/*<Select
                labelInValue
                type="select" 
                className="gouxiaoUomList" 
                onChange={this.handleChange2.bind(this)}
                >
                  {detailData2.map(function (item, key) {
                    return <Select.Option key={key + ''} value={item.value + ''}>{item.text}</Select.Option>
                  })}
                </Select>*/}
                            </p>
                            <span className="l"></span>
                        </a>
                        <a style={{'width': '33%'}}>
                            <p><label>增值税发票号码:</label><span>{detailData.invoiceNumber || '-'}</span></p>
                            <p><label>状态:</label><span>{detailData.statusTxt || '-'}</span></p>
                            <p><label>折扣比例:</label><span>{detailData.discountRate || '0'}</span></p>
                            <p><label>地址、电话:</label><span>{detailData.addressPhone || '-'}</span></p>
                            <p><label>开户行及银行卡号:</label><span>{detailData.bank || '-'}</span></p>
                            <p><label>开单购货单位:</label><span>{detailData.salesUnitName || '-'}</span></p>
                            {saleInvoiceBankRender && <p><label>销方银行:</label><span><Select
                                value={this.state.saleBank}
                                placeholder="请选择销方银行"
                                style={{minWidth: 380}}
                                onSelect={this.onChangeSalsBank.bind(this)}
                            >
                                {
                                    saleInvoiceBank.map((item, index) => {
                                        return <Select.Option key={item.text}
                                                              value={item.text}>{item.text}</Select.Option>
                                    })
                                }
                            </Select></span></p>}
                            <span className="l"></span>
                        </a>
                        <a style={{'width': '35%'}}>
                            <p><label>总金额:</label><span>{this.state.totalAmount || '-'}</span></p>
                            <p><label>金额合计:</label><span>{this.state.amount || '-'}</span></p>
                            <p><label>税额合计:</label><span>{this.state.taxAmount || '-'}</span></p>
                            <p><label>折扣合计:</label><span>{detailData.discount || '0'}</span></p>
                            <p><label>新购货单位:</label><Input type="text" style={{width: '200px'}}
                                                                className="gouxiaoUomList"
                                                                onChange={this.changeRemark2.bind(this)}
                                                                value={this.state.newSalesUnit}/></p>

                            {/*<p><label>快递公司:</label><span>{detailData.expCompany || '-'}</span></p>
              <p><label>邮寄日期:</label><span>{detailData.printDate || '-'}</span></p>
              <p><label>邮寄联系电话:</label><span>{detailData.phone || '-'}</span></p>
              <p><label>快递单号</label><span>{detailData.courierNumber || '-'}</span></p>*/}

                            <p>
                                {/*<label>特殊开票修改类型:</label>*/}
                                <label className="ant-form-item-required">修改类型:</label>
                                <Select
                                    value={{
                                        key: specialBillingType,
                                        label: specialBillingType == 'A' ? '开票单位名称调整' : specialBillingType == 'B' ? '开票产品名称及型号调整' : specialBillingType == 'C' ? '开票单位名称及产品名称型号调整' : specialBillingType == 'D' ? '计量单位调整' : ''
                                    }}
                                    labelInValue
                                    type="select"
                                    style={{width: 270}}
                                    className="gouxiaoUomList"
                                    onChange={this.handleChange3.bind(this)}
                                    dropdownMatchSelectWidth={false}
                                >
                                    <Select.Option key={'A'} value={'A'}>{'开票单位名称调整'}</Select.Option>
                                    <Select.Option key={'B'} value={'B'}>{'开票产品名称及型号调整'}</Select.Option>
                                    <Select.Option key={'C'}
                                                   value={'C'}>{'开票单位名称及产品名称型号调整'}</Select.Option>
                                    <Select.Option key={'D'} value={'D'}>{'计量单位调整'}</Select.Option>
                                </Select>
                            </p>
                            <p>
                                <label>邮寄地址:</label>
                                <Select
                                    mode="combobox"
                                    // defaultValue="a1"
                                    onChange={this.handleChange.bind(this)}
                                    onSelect={this.onSelectFn.bind(this)}
                                    value={this.state.giveAddress}
                                    dropdownMatchSelectWidth={false}
                                    style={{width: 200, float: 'left', marginLeft: '120px'}}
                                    // filterOption={(input, option) => {
                                    //   return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    // }}
                                >
                                    {
                                        detailData3.map(function (item, key) {
                                            return <Select.Option key={key + ''}
                                                                  value={item.value + ''}>{item.text}</Select.Option>
                                        })
                                    }
                                </Select>
                            </p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="dms-table-box">
                <DmsTab className="dms-table-title" options={opts} defaultKey={key}></DmsTab>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(invoiceStaging);


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/specialInvoice.js.js